import { errorCode } from "../constants";
export const setTabDetails = (
	title,
	description,
	key,
	duration,
	brands,
	sections,
	onlyWidgets,
	isDashboard,
	section
) => {
	let body = {
		title: title,
		description: description,
		key: key,
		duration: duration,
		brands: brands,
		sections: sections,
		onlyWidgets: onlyWidgets,
		isDashboard: isDashboard,
		section: section,
	};

	return { type: "SET_TAB_DETAILS", payload: body };
};

export const setTabs = (value) => {
	return { type: "SET_TABS", payload: value };
};

export const setLogScale = (value) => {
	return { type: "SET_LOG_SCALE", payload: value };
};
export const setAIScale = (value) => {
	return { type: "SET_AI_SCALE", payload: value };
};
export const setErrorCode = (value) => {
	let finalValue;
	errorCode?.map((el, i) => {
		return el.key === value ? (finalValue = el.value) : null;
	});
	return { type: "SET_ERROR_CODE", payload: finalValue };
};
export const setPaneValue = (value) => {
	return { type: "SET_PANE_VALUE", payload: value };
};

//base value of worksheet i.e (mentions/unique users)
export const setBaseValue = (value) => {
	return (dispatch) => {
		dispatch({ type: "SET_BASE_VALUE", payload: value });
	};
};
